exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PaypalEmbeddedFields_buttons_2U4jJ,.PaypalEmbeddedFields_embedded_3TZU5{margin-bottom:14px}.PaypalEmbeddedFields_buttons_2U4jJ{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;gap:10px}.PaypalEmbeddedFields_label_jO_0j{display:block;margin:8px 0 4px;font-size:12px;color:#787878}.PaypalEmbeddedFields_field_3ZCbY{height:40px;border:1px solid #dedede;border-radius:4px;padding:0 8px}.PaypalEmbeddedFields_row_2H97j{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;gap:12px}.PaypalEmbeddedFields_col_TzEGC{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}.PaypalEmbeddedFields_saveBlock_21-8E{margin-top:20px;padding-top:14px;border-top:1px solid #dedede}.PaypalEmbeddedFields_saveHeading_2Dp9S{margin-bottom:10px;font-size:13px;font-weight:600;color:#787878}", ""]);

// exports
exports.locals = {
	"buttons": "PaypalEmbeddedFields_buttons_2U4jJ",
	"embedded": "PaypalEmbeddedFields_embedded_3TZU5",
	"label": "PaypalEmbeddedFields_label_jO_0j",
	"field": "PaypalEmbeddedFields_field_3ZCbY",
	"row": "PaypalEmbeddedFields_row_2H97j",
	"col": "PaypalEmbeddedFields_col_TzEGC",
	"saveBlock": "PaypalEmbeddedFields_saveBlock_21-8E",
	"saveHeading": "PaypalEmbeddedFields_saveHeading_2Dp9S"
};